import { Box } from 'components/Box'
import { HeroTitle, HeroSubtitle } from './HeroHeader.styles'
type HeroHeaderProps = {
  title: string
  subtitle: string
}

export const HeroHeader = ({ title, subtitle }: HeroHeaderProps) => {
  return (
    <>
      <Box>
        <HeroTitle>{title}</HeroTitle>
        <HeroSubtitle>{subtitle}</HeroSubtitle>
      </Box>
    </>
  )
}
